<div class="custom-file" *ngIf="!typePicture">
  <input type="file" class="custom-file-input" name="file"
         (change)="addFile($event)">
  <label class="custom-file-label">Izaberi fajl</label>
</div>

<div class="custom-upload-picture" *ngIf="typePicture">
  <input type="file" class="custom-upload-picture__input pointer"
         (change)="addFile($event)">
  <div class="custom-upload-picture__icon custom-upload-picture__icon--center">
    <i class="fa fa-upload"></i>
  </div>
</div>
